// Official YouTube uploads, ideally "Provided to YouTube" tracks that show still album art.
// The id is the part after v= in the YouTube link.
export const TRACKS = [
  { id: '5PgdZDXg0z0', title: 'Space Oddity', artist: 'David Bowie' },
  { id: 'JuSsvM8B4Jc', title: 'Cornfield Chase', artist: 'Hans Zimmer' }
];
